(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bilngwe-product-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-photo-gallery]').forEach(gallery=>{
const track=gallery.querySelector('[data-photo-track]');const slides=Array.from(track.children);const dots=Array.from(gallery.querySelectorAll('[data-photo-index]'));const prev=gallery.querySelector('[data-photo-direction="-1"]');const next=gallery.querySelector('[data-photo-direction="1"]');let current=0;const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
const go=index=>{index=Math.max(0,Math.min(slides.length-1,index));track.scrollTo({left:slides[index].offsetLeft-slides[0].offsetLeft,behavior:reduced.matches?'auto':'smooth'});};
gallery.querySelectorAll('[data-photo-direction]').forEach(button=>button.addEventListener('click',()=>go(current+Number(button.dataset.photoDirection))));dots.forEach((dot,index)=>dot.addEventListener('click',()=>go(index)));track.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();go(current+(event.key==='ArrowRight'?1:-1));}});
const update=()=>{current=Math.round(track.scrollLeft/Math.max(1,track.clientWidth));dots.forEach((dot,index)=>dot.setAttribute('aria-current',String(index===current)));if(prev)prev.disabled=current===0;if(next)next.disabled=current>=slides.length-1;};track.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);update();
});
  } catch(e) { console.error(e); }
})();

})();
